import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import {
  ICustomer,
  ICustomerQuery,
  ICreateCustomer,
  IUpdateCustomer,
  IContactQuery,
  IContact,
  ICreateContact,
  IUpdateContact,
} from "../models/Sale";

export const saleService = {
  getAllCustomer: async (query: ICustomerQuery) => {
    const response = ApiClient.GET<IPaginatedResponse<ICustomer>>(
      `/customers`,
      query,
    );
    return response;
  },
  createCustomer: async (data: ICreateCustomer) => {
    const response = await ApiClient.POST<ICustomer>(`/customers`, data);
    return response;
  },
  updateCustomer: async (id: number, data: IUpdateCustomer) => {
    const response = await ApiClient.PUT<ICustomer>(`/customers/${id}`, data);
    return response;
  },
  deleteCustomer: async (id: number) => {
    const response = await ApiClient.DELETE(`/customers/${id}`);
    return response;
  },
  getAllContact: async (query: IContactQuery) => {
    const response = ApiClient.GET<IPaginatedResponse<IContact>>(
      `/contacts`,
      query,
    );
    return response;
  },
  createContact: async (data: ICreateContact) => {
    const response = ApiClient.POST<IContact>(`/contacts`, data);
    return response;
  },
  updateContact: async (id: number, data: IUpdateContact) => {
    const response = await ApiClient.PUT<IContact>(`/contacts/${id}`, data);
    return response;
  },
  deleteContact: async (id: number) => {
    const response = await ApiClient.DELETE(`/contacts/${id}`);
    return response;
  },
};
